<template>
  <div class="wrapper-outer" id="wrapperOuter">
    <div id="wrapper">
      <div class="content-outer">
        <!-- <div id="content" class="container container-fluid"> -->
          <SearchSection />
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import SearchSection from './search/SearchSection.vue'
// import PageHeader from './murdoch/mu2022/PageHeader.vue'
// import PageFooter from './murdoch/mu2022/PageFooter.vue'
// import { useGlobalStore } from 'client/js/store/global.js'

// const global = useGlobalStore()
// global.fetchChunks()
</script>

<style>
@import "@elastic/react-search-ui-views/lib/styles/styles.css";

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.header {
  text-align: center;
}
</style>


<style lang="scss"></style>
